import { buildField } from '../../common/utils';
import { SUBCATEGORIES } from '../../common/categories';
import { SILVERFORT_API_FIELDS } from '../../common/fields';
import * as actions from './silverfortApiActions';
import { commonActionsReducer } from '../../common/actions';

const { AUTH_TOKENS_AND_USERS, ADFS_AND_MFA } = SUBCATEGORIES;
const {
    ADFS_API_TOKEN,
    SILVERFORT_MFA_API,
    ADMIN_CONSOLE_API_KEY,
    ALLOW_EXTERNAL_RISK_API,
    APP_USER_INACTIVITY_THRESHOLD
} = SILVERFORT_API_FIELDS;

export const fieldsReducer = (state, action) => {
    const newState = { ...state };
    switch (action.type) {
        case actions.UPDATE_ALLOW_EXTERNAL_RISK_API:
            newState[AUTH_TOKENS_AND_USERS.ID].fields[ALLOW_EXTERNAL_RISK_API.ID].value = action.payload.value;
            return newState;
        case actions.UPDATE_MFA_API_USER:
            newState[ADFS_AND_MFA.ID].fields[SILVERFORT_MFA_API.ID].value = action.payload.value;
            return newState;
        case actions.UPDATE_ADFS_API_TOKEN:
            newState[ADFS_AND_MFA.ID].fields[ADFS_API_TOKEN.ID].value = action.payload.value;
            return newState;
        default:
            return commonActionsReducer(state, action, initFieldsState);
    }
};

export const initFieldsState = ({ settings }) => {
    return {
        [AUTH_TOKENS_AND_USERS.ID]: {
            id: AUTH_TOKENS_AND_USERS.ID,
            name: AUTH_TOKENS_AND_USERS.NAME,
            fields: {
                [ADMIN_CONSOLE_API_KEY.ID]: buildField(ADMIN_CONSOLE_API_KEY, settings.AdminConsoleApiKey),
                [ALLOW_EXTERNAL_RISK_API.ID]: buildField(ALLOW_EXTERNAL_RISK_API, settings.AllowExternalRiskApi),
                [APP_USER_INACTIVITY_THRESHOLD.ID]: buildField(
                    APP_USER_INACTIVITY_THRESHOLD,
                    settings.AppUserInactivityDaysThreshold
                )
            }
        },
        [ADFS_AND_MFA.ID]: {
            id: ADFS_AND_MFA.ID,
            name: ADFS_AND_MFA.NAME,
            fields: {
                [ADFS_API_TOKEN.ID]: buildField(ADFS_API_TOKEN, settings.ADFSAPIToken),
                [SILVERFORT_MFA_API.ID]: buildField(SILVERFORT_MFA_API, { user: settings.APIUsername, pass: '' })
            }
        }
    };
};

export const mapToSettings = (saveAll, selectedTab, fields) => {
    const newSettings = {};
    if (saveAll || selectedTab === AUTH_TOKENS_AND_USERS.ID) {
        const tokensFields = fields[AUTH_TOKENS_AND_USERS.ID].fields;
        newSettings.AllowExternalRiskApi = tokensFields[ALLOW_EXTERNAL_RISK_API.ID].value;
    }
    if (saveAll || selectedTab === ADFS_AND_MFA.ID) {
        const tokensFields = fields[ADFS_AND_MFA.ID].fields;
        newSettings.APIUsername = tokensFields[SILVERFORT_MFA_API.ID].value.user;
        newSettings.APIPassword = tokensFields[SILVERFORT_MFA_API.ID].value.pass;
    }
    return newSettings;
};
